import {AvScanStatus, AvScanStatusEnum} from 'av-scan/AvScanDAO';
import BenchlingConfig from 'BenchlingConfig';
import DocumentStore from 'notebook/documents/DocumentStore';
import inspectAllNoteParts from 'notebook/notes/util/inspectAllNoteParts';
import {NoteLinkedFile, NoteLinkedObjectType, NotePart} from 'notebook/util/NoteUtilConstants';
import EntryStore from 'stores/EntryStore';
import StageEntryStore from 'workflows/stage-entries/StageEntryStore';

function isNoteLinkedFile(notePart: NotePart): notePart is NotePart & {item: NoteLinkedFile} {
  const item = notePart.item;
  if (!item) {
    return false;
  }
  return 'type' in item && item.type === NoteLinkedObjectType.NOTE_LINKED_FILE;
}

function collectPendingAvScanFileNames(noteParts: Array<NotePart>): Array<string> {
  const pendingFileNames: Array<string> = [];
  inspectAllNoteParts(noteParts, (notePart) => {
    if (isNoteLinkedFile(notePart)) {
      if (notePart.item.externalFileExcerpt != null) {
        return;
      }
      const scanStatus: AvScanStatus | undefined = notePart.item.scanStatus;
      if (scanStatus === AvScanStatusEnum.PENDING) {
        pendingFileNames.push(notePart.item.name);
      }
    }
  });

  return pendingFileNames;
}

export function getPendingAvScanFileNames(entryId: string): Array<string> {
  if (!BenchlingConfig.ENABLE_ANTIVIRUS_SCANNING) {
    return [];
  }

  const note = StageEntryStore.inStore(entryId)
    ? StageEntryStore.getNote(entryId)
    : EntryStore.inStore(entryId)
      ? EntryStore.getNote(entryId)
      : null;

  if (!note?.noteParts) {
    return [];
  }

  return collectPendingAvScanFileNames(note.noteParts);
}

/** Pending scans across the documents of a multi-document reviewable, e.g. a worksheet's steps. */
export function getPendingAvScanFileNamesForDocuments(documentIds: Array<string>): Array<string> {
  if (!BenchlingConfig.ENABLE_ANTIVIRUS_SCANNING) {
    return [];
  }

  const pendingFileNames: Array<string> = [];
  for (const documentId of documentIds) {
    const note = DocumentStore.getDocument(documentId)?.documentVersion?.entryVersion?.note;
    if (note?.noteParts) {
      pendingFileNames.push(...collectPendingAvScanFileNames(note.noteParts));
    }
  }

  return pendingFileNames;
}
